// The ONE client-side answer to "does this user hold a second factor?"
// (design I3, as revised by spec 12.2). The backend's
// `requires_second_factor_setup` hint is advisory; the client picks the
// remedy from Clerk user state: TOTP enrolled -> reverify, not enrolled ->
// set up.
//
// TOTP ONLY. Passkeys deliberately do not count: a passkey satisfies MFA only
// for a user who already has TOTP (the q346 preflight saw fva=[0,-1] for a
// passkey sign-in without TOTP, [0,0] with it). Counting a passkey would route
// a passkey-only buyer to a reverification they cannot complete.
//
// An email code is NEVER a second factor (D1/I1): this reads only TOTP, never
// `fva[0]`, `email_verified`, or an email-code sign-in.

export type SecondFactorUser = {
  totpEnabled?: boolean | null;
  // Never read (passkeys do not count, 12.2). Declared so object literals in
  // tests that include passkeys stay assignable under excess-property checks.
  passkeys?: readonly unknown[] | null;
};

/**
 * @param totpOverride optimistic TOTP state (after enabling/disabling in this
 *   session, before Clerk's user resource refreshes). Replaces `totpEnabled`.
 */
export function hasSecondFactor(
  user: SecondFactorUser | null | undefined,
  totpOverride?: boolean,
): boolean {
  if (!user) return false;
  return totpOverride ?? user.totpEnabled === true;
}
